import React from "react";
import { 
    buildDirectServicePageQSNativeApp, 
    buildOneBenefitPageQSNAtiveApp, 
    getNativeAppQueryParamsValuesByKey, 
    isEcoproOrBplusDirectServicePage, 
    updateNativeAppQueryParams_LocalStorage 
} from "../../constants/AppMethod";
import MobileHome from "../Home/MobileHome";
import { useQuery } from "../../utils/CustomHooks/UseQuery";
import { LOCALSESSIONDATAKEYS, NATIVE_APP_SELECTION_ATTRIBUTE } from "../../constants/AppConstants";
import { nativeAppRoutePaths } from "../../constants/Routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const NativeAppVersionHandler = () => {
    const history = useHistory();
    const queryParams = useQuery();
    const loginToken = queryParams.get("login_token");
    const UID = queryParams.get("userid");
    const deviceid= queryParams.get("deviceid");
    const language= queryParams.get("language");
    const country= queryParams.get("country");
    const serviceTypeSelected = parseInt(getNativeAppQueryParamsValuesByKey("selection"));

    /*
    *    Skip Logic:
    *    - If the user skips the OneBenefit step, the BOL login screen should be bypassed.
    *    - For EasySetup flow, skipping OneBenefit should navigate directly to the app Setup complete screen.
    */
    const handleAppRedirection = () => {
        const QS = (isEcoproOrBplusDirectServicePage())
        ? buildDirectServicePageQSNativeApp(NATIVE_APP_SELECTION_ATTRIBUTE.SKIP)
        : buildOneBenefitPageQSNAtiveApp(NATIVE_APP_SELECTION_ATTRIBUTE.SKIP, NATIVE_APP_SELECTION_ATTRIBUTE.SKIP);
        updateNativeAppQueryParams_LocalStorage(null, QS, LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO);
        history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
    }

    return (
        <>
            {
                (serviceTypeSelected === NATIVE_APP_SELECTION_ATTRIBUTE.SKIP)
                    ? handleAppRedirection()
                    :  <MobileHome
                        loginToken = {loginToken}
                        UID = {UID}
                        deviceid = {deviceid}
                        language = {language}
                        country = {country}
                    />
            }
        </>
       
    )
}

export default NativeAppVersionHandler;